import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IndicatorElement } from './indicator.component';
import { createCustomElement } from '@angular/elements';

@NgModule({
    declarations: [IndicatorElement],
    imports: [CommonModule],
    exports: [IndicatorElement],
})
export class IndicatorModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(IndicatorElement, {
            injector: this.injector,
        });

        customElements.define('bazis-indicator', el);
    }
}
